import { BackGround, FlexView, Image } from '@facile-it/shark-morph/components'
import * as React from 'react'
import type { LayoutContext } from '../../../../../shark-lib/ts/services/Layout/layoutContext'

interface HeaderProps {
    deviceLayout: LayoutContext.Value
}

export const Header: React.FC<HeaderProps> = ({ deviceLayout }) => {
    return (
        <BackGround
            color="primary"
            padding={deviceLayout.layoutFamily === 'responsive' ? 'none' : 'std'}
            innerWrapperCustomStyle={deviceLayout.layoutFamily === 'responsive' ? { width: '100%' } : {}}
        >
            <FlexView
                gutters={{ tb: 'std', lr: { lg: 'std', xl: 'none' } }}
                vAlignContent="center"
                hAlignContent="between"
                style={{
                    ...(deviceLayout.layoutFamily === 'responsive' ? { maxHeight: '86px' } : {}),
                    '@media only screen and (min-width: 1440px)': {
                        maxWidth: '1280px !important',
                        margin: '0 auto !important',
                    },
                    '@media only screen and (min-width: 1065px) and (max-width: 1439px)': {
                        maxWidth: '1024px !important',
                        margin: '0 auto !important',
                    },
                    '@media only screen and (min-width: 1025px) and (max-width: 1064px)': {
                        maxWidth: '995px !important',
                        margin: '0 auto !important',
                    },
                }}
            >
                <FlexView.Item xs={6} lg={4} xl={3}>
                    <Image size="xxs" margin="none" src={require('@images/logo_bianco.svg')} />
                </FlexView.Item>
                <FlexView.Item xs={6} lg={8} xl={9}>
                    <FlexView hAlignContent="right">
                        <FlexView.Item xs={10} lg={5}>
                            <FlexView hAlignContent="right">
                                <Image
                                    size={deviceLayout.layoutFamily === 'responsive' ? 'xxs' : 'xs'}
                                    margin="none"
                                    src={require('@images/contattaci.svg')}
                                />
                            </FlexView>
                        </FlexView.Item>
                    </FlexView>
                </FlexView.Item>
            </FlexView>
        </BackGround>
    )
}
